<template>
  <v-data-table
    class="pt-2"
    :headers="ENCABEZADOS_COMPANIAS"
    :items="datosFiltrados"
    :page.sync="pagina"
    :items-per-page.sync="itemsPorPagina"
    :loading="cargando"
    hide-default-footer
    :footer-props="opcionesPaginacion"
  >
    <template #item.opciones="{ item }">
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            small
            color="verDetalles"
            v-bind="attrs"
            v-on="on"
            @click="verDetalle(item)"
          >
            <v-icon>visibility</v-icon>
          </v-btn>
        </template>
        <span>Ver detalles</span>
      </v-tooltip>
    </template>

    <template #footer>
      <data-table-pagination
        :pagina="pagina"
        :items-por-pagina="itemsPorPagina"
        :total-items="totalItemsFiltrados"
        :loading="cargando"
        @update:pagina="actualizarPagina"
        @update:items-por-pagina="actualizarItemsPorPagina"
      />
    </template>
  </v-data-table>
</template>

<script>
import DataTablePagination from '../../../../components/Table/DataTablePagination.vue';
import { paginacionMixin } from '../../../../mixins/paginacionMixin';

const ENCABEZADOS_COMPANIAS = [
  { text: 'Compañia', align: 'center', value: 'razon_social' },
  { text: 'Total', align: 'center', value: 'totalCartera' },
  { text: 'Saldo por Docto', align: 'center', value: 'opciones', sortable: false },
];

export default {
  name: 'TablaCarteraCompanias',

  components: {
    DataTablePagination,
  },

  mixins: [paginacionMixin],

  props: {
    cargando: {
      type: Boolean,
      default: false,
    },
    companias: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      ENCABEZADOS_COMPANIAS,
    };
  },

  computed: {
    datosParaPaginar() {
      return this.companias;
    },

    opcionesPaginacion() {
      return { itemsPerPageOptions: [10, 50, 100, -1] };
    },
  },

  methods: {
    verDetalle(item) {
      this.$emit('ver-detalle', item);
    },
  },
};
</script>
